module.exports = __webpack_public_path__ + "static/media/otp_icon.8f0dfb8a.svg";